<template>
  <section class="py-6 mt-4 mx-4 md:mx-8">
    <router-link :to="{ name: 'projects-content', params: { id: $route.params.id } }"
                 class="inline-flex items-center mb-6 text-sm font-medium text-bpblue hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue rounded-md">
      <font-awesome-icon icon="arrow-left" class="-ml-0.5 mr-1.5 h-4 w-4" aria-hidden="true"/>
      {{ $t('projects.back_to_content') }}
    </router-link>

    <div v-if="general.loading" class="py-12 text-center text-sm text-gray-500">
      <font-awesome-icon class="mr-2 h-5 w-5 animate-spin" icon="spinner"/>
      {{ $t('projects.loading_lesson') }}
    </div>

    <div v-else-if="general.lesson" class="mb-8 py-6 bg-white shadow rounded-md">
      <lesson-header-component :lesson="general.lesson" :project-uuid="$route.params.id"></lesson-header-component>

      <!--
        Editor por bloques (FE-030). Hasta que el backend publique la API de bloques
        (LMS-066, LMS-067, LMS-074) queda tras el flag VUE_APP_LMS_LESSON_BLOCKS y se
        muestra el aviso anterior.
      -->
      <lesson-blocks-editor v-if="lmsFeatures.lessonBlocks" :lesson-uuid="general.lesson.uuid ?? $route.params.uuid"
                            @dirty-change="hasUnsavedChanges = $event"></lesson-blocks-editor>
      <div v-else class="mx-6 mt-6 rounded-md bg-blue-50 border border-blue-200 px-4 py-3 text-sm text-blue-800">
        {{ $t('projects.lesson_editing_coming_soon') }}
      </div>
    </div>

    <unsaved-changes-modal :open="isLeaveConfirmationOpen" @leave="confirmLeave" @stay="cancelLeave"></unsaved-changes-modal>
  </section>
</template>

<script>
import ProjectService from "@/services/project/ProjectService";
import NotificationService from "@/services/notification/NotificationService";
import LessonBlocksEditor from "@/views/projects/ProjectEdit/Blocks/LessonBlocksEditor";
import LessonHeaderComponent from "@/views/projects/ProjectEdit/LessonHeaderComponent";
import {useProjectsStore} from "@/stores/projects";
import lmsFeatures from "@/config/lmsFeatures";
import UnsavedChangesModal from "@/components/modals/UnsavedChangesModal";
import {useUnsavedChanges} from "@/composables/useUnsavedChanges";
import {ref} from "vue";

export default {
  name: "ProjectEditContentComponent",
  components: {
    LessonBlocksEditor,
    LessonHeaderComponent,
    UnsavedChangesModal
  },
  setup() {
    // Lo actualiza el editor de bloques con `dirty-change` (FE-032).
    const hasUnsavedChanges = ref(false)

    return {
      hasUnsavedChanges,
      projectsStore: useProjectsStore(),
      ...useUnsavedChanges(hasUnsavedChanges)
    }
  },
  data() {
    return {
      lmsFeatures,
      general: {
        loading: false,
        lesson: null,
      },
    }
  },
  created() {
    this.getLesson()
    this.loadCurriculum()
  },
  watch: {
    '$route.params.uuid'(uuid) {
      if (uuid) this.getLesson()
    }
  },
  methods: {
    // La cabecera (FE-053) necesita el currículo para la miga y anterior/siguiente.
    // Si se entra directamente en esta pantalla, el store aún no lo tiene.
    loadCurriculum() {
      const projectUuid = this.$route.params.id
      if (this.projectsStore.project.uuid === projectUuid && this.projectsStore.project.sections) return

      this.projectsStore.getProject(projectUuid)
          .catch((error) => {
            NotificationService.showApiError(error, this.$t('projects.unexpected_error'))
          })
    },
    getLesson() {
      // El uuid del proyecto se toma de la ruta: el store puede no estar cargado
      // todavía si se recarga la página directamente en esta pantalla.
      const projectUuid = this.$route.params.id
      const lessonUuid = this.$route.params.uuid

      this.general.loading = true
      ProjectService.getLesson(lessonUuid, projectUuid)
          .then((response) => {
            this.general.lesson = response.data
          })
          .catch((error) => {
            this.general.lesson = null
            NotificationService.showApiError(error, this.$t('projects.unexpected_error'))
          })
          .finally(() => {
            this.general.loading = false
          })
    },
  }
}
</script>
